export default 'Username-Password-Authentication';
